<template>
  <div class="home">
    <div class="breadcrumbs"></div>
    <PageTitle :pageHeading="dashboardTitle" :rightsideButton="false">
    </PageTitle>
    <!--- current tickets metrics---->

    <CurrentMetrics></CurrentMetrics>
    
    <!---- ticket summary----->
    <v-row>
      <v-col>
        <TicketSummary></TicketSummary>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="8">
        <!-- <TicketByGroups />  -->
        <TicketByChannel />
      </v-col>
      <v-col cols="4">
        <ticket-priority></ticket-priority>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8">
        <TicketByTypes />
      </v-col>
    </v-row>
    <!-- <v-row class="mb-5">
      <v-col cols="12" lg="6"> </v-col>
      <v-col cols="12" lg="6"> <v-card height="330px"></v-card> </v-col>
    </v-row> -->
  </div>
</template>

<script>
import PageTitle from "@/components/shared/PageTitle.vue";
import CurrentMetrics from "@/components/dashboard_widgets/CurrentMetrics";
import TicketSummary from "@/components/dashboard_widgets/TicketSummary";
import TicketByTypes from "@/components/dashboard_widgets/TicketByTypes";
//import TicketByGroups from "@/components/dashboard_widgets/TicketByGroups";
import TicketPriority from "@/components/dashboard_widgets/TicketPriority.vue";
import TicketByChannel from "@/components/dashboard_widgets/TicketByChannel.vue";

export default {
  name: "DashboardView",
  components: {
    PageTitle,
    CurrentMetrics,
    TicketSummary,
    TicketByTypes,
    TicketPriority,
    TicketByChannel,
    //TicketByGroups,
  },
  data() {
    return {
      dashboardTitle: "",
      dayTime: "",
    };
  },
  computed: {
    user() {
      let username = this.$store.getters["auth/username"];
      return typeof username == "object"
        ? `${username.firstName || ""}`
        : username;
    },
  },

  mounted() {
    this.timeValidate();
    this.dashboardTitle = `Good  ${this.dayTime}, ${this.user}!`;
  },

  methods: {
    timeValidate: function () {
      var currentTime = new Date();
      var hour = currentTime.getHours();
      this.dayTime =
        hour < 12 ? "Morning" : hour < 17 ? "Afternoon" : "Evening";
    },
  },
};
</script>
